var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivFitPreferredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10C21.78 10 20 11.78 20 14C20 16.22 21.78 18 24 18C26.22 18 28 16.22 28 14C28 11.78 26.22 10 24 10ZM44 2V12H40V8H8V12H4V2H8V6H40V2H44ZM30 22.52V46H26V36H22V46H18V22.52C13.86 20.34 11 16 11 11V10H15V11C15 16 19 20 24 20C29 20 33 16 33 11V10H37V11C37 16 34.14 20.34 30 22.52Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivFitPreferredIcon);
export default __webpack_public_path__ + "static/media/ActivFitPreferredIcon.74fefe117efbc6c02760c6804e54878a.svg";
export { ForwardRef as ReactComponent };